<template>
  <a-modal
    :visible="visible"
    :title="$t('auto.editText')"
    :closable="false"
    :maskClosable="false"
    @ok="save"
    @cancel="cancel"
  >
    <div>
      <div style="margin-bottom: 8px;">
        <p style="margin-bottom: 4px;">{{ $t("auto.textContent") }}</p>
        <a-input
          style="width: 100%"
          v-model="tempEditText"
          @input="onTextInput"
        />
      </div>
      <div style="margin-bottom: 8px;">
        <p style="margin-bottom: 4px;">{{ $t("auto.color") }}</p>
        <div style="display: flex; flex-wrap: wrap; gap: 4px; align-items: center;">
          <div
            v-for="color in colors"
            :key="color"
            :style="{
              backgroundColor: color,
              width: '24px',
              height: '24px',
              borderRadius: '50%',
              marginRight: '4px',
              cursor: 'pointer',
              border: tempEditColor === color ? '2px solid #1890ff' : '1px solid #e8e8e8'
            }"
            @click="selectColor(color)"
          ></div>
        </div>
      </div>
      <div>
        <p style="margin-bottom: 4px;">{{ $t("auto.sizePx") }}</p>
        <a-slider
          :min="10"
          :max="60"
          :step="1"
          v-model="tempEditSize"
          @change="onSizeChange"
        />
        <p style="margin-left: 4px; margin-top: 6px;">
          {{ $t("auto.selectedSize") }}: {{ tempEditSize }}{{ $t("message.pixelUnit") }}
        </p>
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'TextEditModal',
  props: {
    text: {
      type: Object,
      required: true
    },
    colors: {
      type: Array,
      required: true  
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tempEditText: this.text.text,
      tempEditColor: this.text.color,
      tempEditSize: this.text.size
    };
  },
  methods: {
    onTextInput() {
      this.text.text = this.tempEditText;
      this.$emit('redraw');
    },
    selectColor(color) {
      this.tempEditColor = color;
      this.text.color = color;
      this.$emit('redraw');
    },
    onSizeChange() {
      this.text.size = this.tempEditSize;
      this.$emit('redraw');  
    },
    save() {
      this.$emit('save', {
        text: this.tempEditText,
        color: this.tempEditColor,
        size: this.tempEditSize
      });
    },
    cancel() {
      this.$emit('cancel');
    }
  }
};
</script> 